// import throttle from 'lodash.throttle';
import TweenLite from "gsap/umd/TweenLite.js";
import React from 'react';
import styled from '@emotion/styled'
import { Grid } from 'style';




class GoertekVisualizerComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      variableFontSupport: false
    }

    this.audioActive = false;

    this.meter = React.createRef();
    this.frequency = React.createRef();
    this.hero = React.createRef();
    this.svg = React.createRef();

    this.initAudio = {};
    this.analyser = {};
    this.action = {};


    this.renderLoop = this.renderLoop.bind(this);
  }

  componentDidMount() {
    this.setState({ variableFontSupport: "fontVariationSettings" in document.documentElement.style });

    this.initAudio = {

      remove: () => {

        if (this.audioSrc) {

          // remove stream
          if (this.audioStream) {

            var tracks = this.audioStream.getTracks();

            for (var i = 0; i < tracks.length; i++) {
              var track = tracks[i];
              track.stop();
            }
          }

          // remove audio
          if (this.audio) {
            this.audio.pause();
            this.audio.remove();
          }

          // disconnect
          // this.audioSrc.disconnect();

          // reset references
          this.audio = null;
          this.audioSrc = null;
          this.audioStream = null;
        }
      },

      init: (node) => {

        var morphTo, j;
        if (node.playing || node.loading) {

          // remove request
          this.initAudio.remove(node);

          // remove active calss
          node.classList.remove("active");

          // reset flag
          node.playing = false;

          morphTo = (node.audiotype === "sound") ? "play" : "record"

          // change icon to play
          const nodeIcons = node.querySelectorAll('.icon');
          for (j = 0; j < nodeIcons.length; j++) {
            TweenLite.to(nodeIcons[j], 0.3, { morphSVG: this.action.states[morphTo][j] });
          }

        } else {

          for (var action, i = 0; action = [this.action.music, this.action.sound, this.action.microphone][i]; i++) {

            if (action.classList.contains("active")) {

              // remove active calss
              action.classList.remove("active");

              // reset flag
              action.playing = false;
              this.audioActive = false;

              morphTo = (action.audiotype === "sound") ? "play" : "record"

              // change icon to play
              for (j = 0; j < action.icon.length; j++) {
                TweenLite.to(action.icon[j], 0.3, { morphSVG: this.action.states[morphTo][j] });
              }

              // remove old connections & audio
              this.initAudio.remove(action);
            }
          }

          // mobile click hack
          if (this.AudioContext.state === 'suspended') {

            var resume = () => {

              // resume connection
              this.AudioContext.resume();
              this.audioActive = true;

              setTimeout(() => {

                if (this.AudioContext.state === 'running') {

                  // callback to audio type
                  this.initAudio[node.audiotype](node);

                  // remove touch listener
                  this.removeEvent(document, "touchend", { callback: resume });
                }

              }, 0);
            };

            this.addEvent(document, "touchend", { callback: resume });

          } else {
            // callback to audio type
            this.initAudio[node.audiotype](node);
          }
        }

      },

      sound: (node) => {

        // set loading flag
        node.loading = true;

        // add src
        if (!this.audio) {
          this.audio = new window.Audio();
        }
        this.audio.src = node.src;
        this.audio.play();

        // add class
        this.audioActive = true;
        node.classList.add("active");

        // change icon to preload

        const nodeIcons = node.querySelectorAll('.icon');
        for (var i = 0; i < nodeIcons.length; i++) {
          TweenLite.to(nodeIcons[i], 0.3, { morphSVG: this.action.states.square[i] });
        }


        var zoomed = false;
        var preloadAnimation = () => {

          if (!node.loaded && node.loading) {

            let zoomLevel = 1;

            if (zoomed) {
              zoomed = false;
              zoomLevel = 1;
            } else {
              zoomed = true;
              zoomLevel = 1.5;
            }

            TweenLite.to(this.svg.current, 0.5, {
              scale: zoomLevel,
              onComplete: () => {
                preloadAnimation();
              }
            });
          }
        }

        // start prelo
        preloadAnimation();

        // preload callback
        var playback = () => {

          // loaded flage
          this.audioActive = true;
          node.loading = false;
          node.loaded = true;
          node.playing = true;

          // reset logo scale
          TweenLite.to(this.svg.current, 0.5, { scale: 1 });

          // change icon to preload
          const nodeIcons = node.querySelectorAll('.icon');
          for (var i = 0; i < nodeIcons.length; i++) {
            TweenLite.to(nodeIcons[i], 0.3, { morphSVG: this.action.states.pause[i] });
          }

          // setup src
          this.audioSrc = this.AudioContext.createMediaElementSource(this.audio);
          this.audioSrc.connect(this.analyser);
          this.audioSrc.connect(this.AudioContext.destination);
        }

        // ended callback
        var ended = () => {

          // reset flag
          this.audioActive = false;
          node.playing = false;
          node.loaded = false;

          // change icon to play
          const nodeIcons = node.querySelectorAll('.icon');
          for (var i = 0; i < nodeIcons.length; i++) {
            TweenLite.to(nodeIcons[i], 0.3, { morphSVG: this.action.states.play[i] });
          }

          // remove old connections & audio
          this.initAudio.remove();

          // remove class
          node.classList.remove("active");
        }

        // audio listeners
        this.addEvent(this.audio, "canplaythrough", { callback: playback, scope: node });
        this.addEvent(this.audio, "ended", { callback: ended, scope: node });
      },

      microphone: (node) => {

        // setup microphone
        window.navigator.getUserMedia = window.navigator.getUserMedia || window.navigator.webkitGetUserMedia || window.navigator.mozGetUserMedia;

        window.navigator.getUserMedia({
          audio: true,
          video: false
        }, (stream) => {

          // add class
          this.audioActive = false;
          node.classList.add("active");

          // set flag
          node.playing = true;

          // change icon to disconnect
          for (var i = 0; i < node.icon.length; i++) {
            TweenLite.to(node.icon[i], 0.3, { morphSVG: this.action.states.disconnect[i] });
          }

          this.audioStream = stream;
          this.audioSrc = this.AudioContext.createMediaStreamSource(this.audioStream);
          this.audioSrc.connect(this.analyser);

        }, () => {

          // error message
        });
      },

      meter: (arr) => {
        if (!this.meter.current) {
          return 0;
        }
        this.meter.current.context.clearRect(0, 0, this.meter.current.width, this.meter.current.height);

        // this.meter.current.context.fillStyle = "green";
        // this.meter.current.context.fillRect(0, 0, this.meter.current.width, this.meter.current.height);

        var values = 0;
        var length = arr.length;

        for (var i = 0; i < length; i++) {

          var percentage = (100 / 255 * arr[i]);

          values += percentage;

          this.meter.current.context.fillStyle = "#FFFFFF";
          this.meter.current.context.fillRect(i * 3, this.meter.current.height - (this.meter.current.height / 100 * percentage), 3, (this.meter.current.height / 100 * percentage));
          this.meter.current.context.fill();
        }

        // return the average
        return Math.round(values / length);
      }
    }


    this.action = {
      music: document.querySelector('.music'),
      sound: document.querySelector('.sound'),
      microphone: document.querySelector('.microphone')
    };
    this.action.music.src = this.action.music.getAttribute("data-music-src");
    this.action.music.audiotype = "sound";
    this.action.music.text = this.action.music.querySelector('p');
    this.action.music.svg = this.action.music.querySelector('svg');
    this.action.music.icon = this.action.music.querySelectorAll('.icon');

    this.action.sound.src = this.action.sound.getAttribute("data-sound-src");
    this.action.sound.audiotype = "sound";
    this.action.sound.text = this.action.sound.querySelector('p');
    this.action.sound.svg = this.action.sound.querySelector('svg');
    this.action.sound.icon = this.action.sound.querySelectorAll('.icon');

    this.action.microphone.audiotype = "microphone";
    this.action.microphone.text = this.action.microphone.querySelector('p');
    this.action.microphone.icon = this.action.microphone.querySelectorAll('.icon');

    this.action.states = {
      square: ["M0,0h7v12H0V0", "M5,0h7v12H5V0"],
      pause: ["M0,0h4v12H0V0", "M8,0h4v12H8V0"],
      play: ["M0,0l7,3.5v5L0,12V0", "M5,2.5L12,6l0,0L5,9.5V2.5"],
      record: ["M6,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,12,6,12z M6,1.5c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S8.5,1.5,6,1.5z", "M6,3.5c1.4,0,2.5,1.1,2.5,2.5S7.4,8.5,6,8.5S3.5,7.4,3.5,6S4.6,3.5,6,3.5"],
      disconnect: ["M6,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,12,6,12z M6,1.5c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S8.5,1.5,6,1.5z", "M6,1c2.8,0,5,2.2,5,5s-2.2,5-5,5S1,8.8,1,6S3.2,1,6,1"]
    };


    this.svg.current.letters = this.svg.current.querySelectorAll(".letter");
    this.svg.current.morph = ["M51.3,24.4V26c0,16-10.6,25.9-24.7,25.9C11.8,51.9,0.6,42,0.6,26C0.6,9.5,12.7,0.1,27.7,0.1c7.4,0,13.5,2.6,16.3,4.6v4.1c-3-2.3-9.1-5-16.4-5C14.3,3.7,4.4,12.2,4.4,26c0,13.4,9.3,22.2,22.3,22.2c11.8,0,20.1-8.1,20.8-20.5L40,31l-8.9-3.7l-9,3.7v-3.7l8.9-3.7l8.9,3.7l8.5-3.8L51.3,24.4z", "M59.1,26.1c0-14,10.7-25.9,25.4-25.9S110,12,110,26.1c0,14-10.7,25.8-25.4,25.8S59.1,40,59.1,26.1zM106.2,26.1c0-12.2-8.9-22.3-21.6-22.3c-12.7,0-21.6,10.1-21.6,22.3c0,12.3,9,22.1,21.6,22.1C97.2,48.2,106.2,38.3,106.2,26.1z", "M156.8,47.6v3.5h-34V0.8H156v3.5h-29.6v20.9l7.4-3.5l11,4l9.4-4.1v3.7l-9.4,4.1l-11-4l-7.4,3.5v18.6H156.8z", "M204.5,51.2l-16.4-21.3l-6.5-2.9l-7.7,2.9v21.3h-3.7V0.8h17.6c10,0,19.1,3.6,19.1,14.7c0,9.6-6.8,14.2-13.1,15.2l15.6,20.3H204.5z M181.6,23.3l9.2,4.3c6.2,0,12.3-4.1,12.3-12c0-7.9-6.1-11.2-15.3-11.2h-13.9v21.8L181.6,23.3z", "M253.3,3.1v3.7l-11.3-3l-6.8,1.3v46h-3.7V5.9l-6.1,1.2l-11.8-3.3V0.1l11.8,3.3l16.6-3.3L253.3,3.1z", "M298,47.6v3.5h-34V0.8h33.3v3.5h-29.6v20.9l7.4-3.5l11,4l9.4-4.1v3.7l-9.4,4.1l-11-4l-7.4,3.5v18.6H298z", "M343.8,51.2l-28.7-24.8v24.8h-3.7V0.8h3.7v24.1L343,0.8h5.3l-28.5,24.8l29.6,25.5H343.8z"];

    this.setup();
  }

  addEvent(node, event_type, _options) {

    var options = _options || {};
    options.callback = options.callback || node["callback"];
    options.bubble = (options.bubble !== "undefined") ? false : true;

    node.addEventListener(event_type, (options.scope ? options.callback.bind(options.scope) : options.callback), options.bubble);
  }
  removeEvent(node, event_type, _options) {

    var options = _options || {};
    options.callback = options.callback || node["callback"];
    options.bubble = (options.bubble !== "undefined") ? false : true;

    node.removeEventListener(event_type, options.callback, options.bubble);
  }

  setup() {

    // section build flag
    this.build = true;

    if (window.AudioContext || window.webkitAudioContext) {

      // setup audio contect
      this.AudioContext = new (window.AudioContext || window.webkitAudioContext)();

      // audio references
      this.audio = null;
      this.audioSrc = null;
      this.audioStream = null;

      // setup audio analyser
      this.analyser = this.AudioContext.createAnalyser()
      this.analyser.fftSize = 32;

      // setup actions
      // u.ce(this.action.music, { callback: this.action.music.clicked });
      // u.ce(this.action.sound, { callback: this.action.sound.clicked });
      // u.ce(this.action.microphone, { callback: this.action.microphone.clicked });

      // setup svg fallback
      if (!this.state.variableFontSupport) {

        for (var i = 0; i < this.svg.current.letters.length; i++) {
          var letter = this.svg.current.letters[i];

          // console.log(letter, this.svg.current.morph[i]);
          letter.tween = TweenLite.to(letter, 1, { morphSVG: this.svg.current.morph[i] });
          letter.tween.pause();
        }
      }

      // setup audio meter
      this.meter.current.context = this.meter.current.getContext("2d");
      this.meter.current.width = this.meter.current.width = 48;
      this.meter.current.height = this.meter.current.height = 57;

      // start render loop
      this.renderLoop();
    }
  }
  renderLoop() {
    // if (this.audioActive == true) {
    var frequencyData = new window.Uint8Array(this.analyser.frequencyBinCount);

    this.analyser.getByteFrequencyData(frequencyData);

    // gets the average percentage of all sound frequencies
    var average = this.initAudio.meter(frequencyData);

    // update frequency
    // console.log('update frequency');
    if (this.frequency.current) {
      this.frequency.current.innerHTML = average + "%";
    }

    if (this.state.variableFontSupport) {

      // update element variant
      if (this.hero.current) {
        this.hero.current.style.setProperty("--elem-weight", average);
      }

    } else {

      for (var i = 0; i < this.svg.current.letters.length; i++) {
        var letter = this.svg.current.letters[i];

        // update morph
        letter.tween.progress(average / 100);
      }
    }

    // }
    // repeat loop
    if (this.frequency.current) {
      window.requestAnimationFrame(this.renderLoop);
    }
  }


  render() {
    const { variableFontSupport } = this.state;
    return (
      <Grid.Wrapper backgroundColor={'#000'}>
        <Grid.Container>
          <Visualizer className={[`visible`, variableFontSupport ? 'support' : 'default'].join(' ')}>

            <dl className="description">
              <dt>Type</dt>
              <dd>Variable typeface</dd>
            </dl>

            <div className="content">

              <ul className="grid">
                <li className="line"></li>
                <li className="line"></li>
                <li className="line"></li>
              </ul>

              <h1 style={{ "--elem-weight": 0 }} ref={this.hero}>G<span>OERTEK</span></h1>

              <svg className="letters" ref={this.svg} version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 350 52">
                <path className="letter" d="M51.3,25.4V26c0,16-10.6,25.9-24.7,25.9C11.8,51.9,0.6,42,0.6,26C0.6,9.5,12.7,0.1,27.7,0.1c7.4,0,13.5,2.6,16.3,4.6v4.1c-3-2.3-9.1-5-16.4-5C14.3,3.7,4.4,12.2,4.4,26c0,13.4,9.3,22.2,22.3,22.2c11.3,0,19.6-7.5,20.7-19.3l-7.3,0l-9,0h-8.9v-3.5H31l9,0l8.4,0L51.3,25.4z"></path>
                <path className="letter" d="M59.1,26.1c0-14,10.7-25.9,25.4-25.9S110,12,110,26.1c0,14-10.7,25.8-25.4,25.8S59.1,40,59.1,26.1zM106.2,26.1c0-12.2-8.9-22.3-21.6-22.3c-12.7,0-21.6,10.1-21.6,22.3c0,12.3,9,22.1,21.6,22.1C97.2,48.2,106.2,38.3,106.2,26.1z"></path>
                <path className="letter" d="M156.8,47.6v3.5h-34V0.8H156v3.5h-29.6v19.1l7.4,0l11,0l9.4,0V27l-9.4,0l-11,0l-7.4,0v20.6H156.8z"></path>
                <path className="letter" d="M204.6,51.2l-15.9-20.8c-0.8,0-6.3,0-7,0l-7.7,0v20.8h-3.7V0.8h17.9c9.6,0,18.8,3.6,18.8,14.7c0,9.1-6.2,13.2-13.7,14.4l16.2,21.2H204.6z M173.9,26.8h8.1c6.6,0,7.2,0,8.8-0.1c7.4-0.6,12.3-4,12.3-11.1c0-7.9-6.1-11.2-15-11.2h-14.2V26.8z"></path>
                <path className="letter" d="M253.3,4.4l-11.3,0l-6.8,0v46.8h-3.7V4.4l-6.1,0l-11.8,0V0.8l11.8,0l16.6,0l11.3,0V4.4z"></path>
                <path className="letter" d="M298,47.6v3.5h-34V0.8h33.3v3.5h-29.6v19.1l7.4,0l11,0l9.4,0V27l-9.4,0l-11,0l-7.4,0v20.6H298z"></path>
                <path className="letter" d="M343.8,51.2l-28.7-24.8v24.8h-3.7V0.8h3.7v24.1L343,0.8h5.3l-28.5,24.8l29.6,25.5H343.8z"></path>
              </svg>

            </div>

            <dl className="actions">
              <dt>Sound effects</dt>
              <dd>
                <ul>
                  <li className="music" data-music-src="/styleguide-media/track.mp3" type="sound" onClick={(e) => { this.initAudio.init(e.target) }}>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12 12" style={{ transform: "matrix(1, 0, 0, 1, 0, 0)" }}>
                      <path className="icon" d="M0,0l7,3.5v5L0,12V0" data-original="M0,0l7,3.5v5L0,12V0"></path>
                      <path className="icon" d="M5,2.5L12,6l0,0L5,9.5V2.5" data-original="M5,2.5L12,6l0,0L5,9.5V2.5"></path>
                    </svg>
                    <p>Music</p>
                  </li>
                  <li className="sound" data-sound-src="/styleguide-media/sound.mp3" type="sound" onClick={(e) => { this.initAudio.init(e.target) }}>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12 12" style={{ transform: "matrix(1, 0, 0, 1, 0, 0)" }}>
                      <path className="icon" d="M0,0l7,3.5v5L0,12V0" data-original="M0,0l7,3.5v5L0,12V0"></path>
                      <path className="icon" d="M5,2.5L12,6l0,0L5,9.5V2.5" data-original="M5,2.5L12,6l0,0L5,9.5V2.5"></path>
                    </svg>
                    <p>Sound</p>
                  </li>
                  <li className="microphone" type="microphone" onClick={(e) => { this.initAudio.init(e.target) }}>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12 12">
                      <path className="icon" d="M6,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,12,6,12z M6,1.5c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S8.5,1.5,6,1.5z"></path>
                      <path className="icon" d="M6,3.5c1.4,0,2.5,1.1,2.5,2.5S7.4,8.5,6,8.5S3.5,7.4,3.5,6S4.6,3.5,6,3.5"></path>
                    </svg>
                    <p>Microphone</p>
                  </li>
                </ul>
              </dd>
            </dl>

            <dl className="frequency">
              <dt>Volume:</dt>
              <dd ref={this.frequency}>0%</dd>
            </dl>

            <canvas className="meter" width="48" height="57" ref={this.meter}></canvas>

          </Visualizer>
        </Grid.Container>
      </Grid.Wrapper>
    )
  }
}

const Visualizer = styled.div`


  /* Goertek weights variables */
  @font-face {
    font-family: "GoertekGX";
    src: url("/fonts/GoertekVariableGX.ttf") format("truetype-variations"),
      url("/fonts/GoertekVariableGX.ttf") format("truetype");
  }

  /* Goertek osci variables */
  @font-face {
    font-family: "osciGX";
    src: url("/fonts/osciGX.ttf") format("truetype-variations"),
      url("/fonts/osciGX.ttf") format("truetype");
  }


  /* Goertek */
  @font-face {
    font-family: "Goertek";
    src: url("/fonts/Goertek-Bold.woff2") format("woff2"),
      url("/fonts/Goertek-Bold.woff") format("woff");
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: "Goertek";
    src: url("/fonts/Goertek-Regular.woff2") format("woff2"),
      url("/fonts/Goertek-Regular.woff") format("woff");
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: "Goertek";
    src: url("/fonts/Goertek-Light.woff2") format("woff2"),
      url("/fonts/Goertek-Light.woff") format("woff");
    font-weight: 200;
    font-style: normal;
  }

  &.support h1,
  &.support h1 span {
    font-family: "osciGX", Verdana, sans-serif;
    font-weight: 300;
  }

  ul, dl, dd, p{
    margin: 0;
    padding: 0;
  }
  ul li {
    display: inline-block;
    vertical-align: top;
  }
  dl dt {display: none;}

  position: relative;
  padding: 50px;
  width: calc(100% - 100px);
  background-color: #000;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 60vh;

  dl.description {
    position: absolute;
    top: 50px;
    left: 50px;
    opacity: 0;
    transition: opacity .5s ease-in-out .2s
  }

  &.visible dl.description {
      opacity: 1
  }

  dl.description dd {
    font-size: 14px;
    line-height: 1em;
    text-transform: uppercase;
    color: #FFF
  }

 .content {
    position: relative;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center
}

 .content ul.grid {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    width: 100%;
    opacity: 0;
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    transform: translateY(-50%)
}

 .content ul.grid li.line:nth-of-type(1) {
    transition: width .5s cubic-bezier(.8,.04,.58,.92) .3s
}

 .content ul.grid li.line:nth-of-type(2) {
    transition: width .5s cubic-bezier(.8,.04,.58,.92) .4s
}

 .content ul.grid li.line:nth-of-type(3) {
    transition: width .5s cubic-bezier(.8,.04,.58,.92) .5s
}

 .content ul.grid li.line {
    width: 0;
    margin: 36px 0;
    height: 1px;
    background-color: #4C4C4C
}

&.visible .content ul.grid {
    opacity: 1
}

&.visible .content ul.grid li.line {
    width: 100%
}

&.visible .content h1 {
  position: relative;
  line-height: 1em;
  color: #FFFFFF;
  text-align: center;
  opacity: 0;
  display: block;
  margin: 0;
	font-variation-settings: "osci" var(--elem-weight);
	font-size: 204px;
}

&.visible.default .content h1 {display: none;}
&.visible.support .content svg {display: none;}

.content h1 {
    position: relative;
    line-height: 1em;
    color: #FFF;
    opacity: 0;
    display: block;
    font-size: 204px
}

.content h1 span {
    line-height: inherit
}

&.visible .content h1 {
    opacity: 1;
    transition: opacity .8s ease-in-out .6s
}

.content svg {
    display: block;
    position: relative;
    width: 1012px;
    height: auto;
    margin: 17px auto 0;
    opacity: 0
}

.content svg {
    opacity: 1;
    transition: opacity .8s ease-in-out .6s
}
.content svg .letter {
  fill: #FFFFFF;
}

dl.actions {
    position: relative;
    opacity: 0;
    transition: opacity .5s ease-in-out .2s
}

&.visible dl.actions {
    opacity: 1
}

 dl.actions dt {
    display: inline-block;
    font-size: 14px;
    line-height: 1em;
    color: #FFF;
    text-transform: uppercase;
    vertical-align: top;
    padding-top: 19px;
    position: absolute;
    top: 0;
    left: 0
}

 dl.actions dd {
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    line-height: 1em;
    text-align: center;
    position: relative;
    right: 0;
    left: 0;
    width: 100%
}

 dl.actions dd ul li {
    font-size: 0;
    border: 1px solid #FFF;
    background-color: #000;
    color: #FFF;
    padding: 18px 0;
    margin: 0 15px;
    cursor: pointer;
    width: 270px
}

 dl.actions dd ul li p, dl.frequency dd, dl.frequency dt {
    font-size: 14px;
    line-height: 1em;
    text-transform: uppercase;
    display: inline-block;
    pointer-events: none;
}
dl.actions dd ul li svg{
  pointer-events: none;
}

 dl.actions dd ul li.active {
    background-color: #FFF;
    color: #000
}

 dl.actions dd ul li.active .icon {
    background-color: #000
}

 dl.actions dd ul li p {
    color: inherit;
    vertical-align: middle
}

 dl.actions dd ul li svg {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 10px;
    vertical-align: middle
}

dl.actions dd ul li svg .icon {
    fill: #fff;
}
dl.actions dd ul li.active svg .icon {
    fill: #000;
}

ul.sections li.specimen ul.list li dl dd svg path,ul.sections.default li.slider .content svg path {
    fill: #FFF
}

 dl.frequency {
    position: absolute;
    top: 50px;
    right: 50px;
    opacity: 0;
    transition: opacity .5s ease-in-out .2s
}

&.visible dl.frequency {
    opacity: 1
}

 dl.frequency dt {
    color: #FFF;
    margin-right: 6px
}

 dl.frequency dd {
    color: #FFF;
    width: 26px
}

 .meter {
    position: absolute;
    bottom: 50px;
    right: 50px
}

@media only screen and (max-width: 1400px) {



     dl.description {
        top: 30px;
        left: 30px
    }

     dl.description dd {
        font-size: 12px
    }

     .content ul.grid {
        margin-top: 6px
    }

     .content ul.grid li.line {
        margin: 27px 0
    }

    &.support .content h1 {
        font-size: 153px
    }

     dl.actions dd, dl.actions dd ul li p, dl.actions dt, dl.frequency dd, dl.frequency dt {
        font-size: 12px
    }

    .content svg {
        width: 760px;
        margin: 13px auto 0
    }

     dl.actions dd ul li {
        width: 200px
    }

     dl.frequency {
        top: 30px;
        right: 30px
    }

     .meter {
        bottom: 30px;
        right: 30px
    }
}

@media only screen and (max-width: 1000px) {
     dl.actions dd ul li {
        margin:0 10px;
        width: 150px
    }
}

@media only screen and (max-width: 800px) {
     dl.actions dd ul li p,.content ul.grid, &.support .content h1 span {
        display:none
    }


     dl.description {
        top: 30px;
        left: 10px
    }

     dl.description dd {
        font-size: 10px
    }

     .content ul.grid {
        margin-top: 8px
    }

     .content ul.grid li.line {
        margin: 36px 0
    }

    &.support .content h1 {
        font-size: 204px
    }

     dl.actions dd, dl.frequency dd, dl.frequency dt {
        font-size: 10px
    }

    .content svg {
        width: calc(100vw - 100px);
        padding: 130px 0
    }

     dl.actions {
        text-align: center;
        width: calc(100% + 20px);
        margin-left: -10px
    }

     dl.actions dt {
        font-size: 10px;
        position: relative;
        padding-top: 0;
        padding-bottom: 30px
    }

     dl.actions dd ul li {
        padding: 16px 0;
        margin: 0 10px;
        width: calc((100% - 66px)/ 3)
    }

     dl.actions dd ul li svg {
        margin: 0;
        width: 16px;
        height: 16px
    }

     dl.frequency {
        top: 30px;
        right: 10px
    }

     .meter {
        bottom: auto;
        right: 10px;
        top: 70px
    }
}

`;

export default GoertekVisualizerComponent;
